module.exports = __webpack_public_path__ + "static/BT1-pirates-30a26fd3ab3c884f70afdb713447202d.jpg";